__turbopack_context__.v({
  "active": "sky-drawer-module__xyqABa__active",
  "assetsDrawer": "sky-drawer-module__xyqABa__assetsDrawer",
  "button": "sky-drawer-module__xyqABa__button",
  "buttonText": "sky-drawer-module__xyqABa__buttonText",
  "hdriIntensityWrapper": "sky-drawer-module__xyqABa__hdriIntensityWrapper",
  "hdriTitle": "sky-drawer-module__xyqABa__hdriTitle",
  "hdriTypeWrapper": "sky-drawer-module__xyqABa__hdriTypeWrapper",
  "iconSearch": "sky-drawer-module__xyqABa__iconSearch",
  "selected": "sky-drawer-module__xyqABa__selected",
  "skyboxCard": "sky-drawer-module__xyqABa__skyboxCard",
  "skyboxGrid": "sky-drawer-module__xyqABa__skyboxGrid",
  "slider": "sky-drawer-module__xyqABa__slider",
  "title": "sky-drawer-module__xyqABa__title",
  "topSection": "sky-drawer-module__xyqABa__topSection",
});
